import { FormService } from '../services'

export default function updateForm(form) {
  return new Promise((resolve, reject) => {
    FormService.updateForm(form)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}